import React, { useRef, useState, KeyboardEvent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Wrapper, Header, ColumnLeft, ColumnRight, Heading, EditButton, CancelButton, Body, BodyText, ButtonsWrapper } from './styled';
import { Button } from 'elements';
import InputAreaAI from "components/InputAreaAI";
import { DataType } from "components/InputAreaAI/components/Assistant/data";

interface GoalProps {
  onUpdate: (fields: { [key: string]: any }, areaId: string, goalId: string, callback?: () => void) => void;
}

const Goal: React.FC<GoalProps> = ({ onUpdate }) => {
  const { selectedGoalAction } = useSelector((state: any) => state.globalReducer);
  const [isEditing, setIsEditing] = useState(false);
  const [editedText, setEditedText] = useState(selectedGoalAction?.goal?.goal_name || '');
  const [isSaving, setIsSaving] = useState(false);

  const $inputRef = useRef(null);
  
  // Reset editedText and isEditing state when selectedGoalAction changes
  useEffect(() => {
    setEditedText(selectedGoalAction?.goal?.goal_name || '');
    setIsEditing(false);
    setIsSaving(false);
  }, [selectedGoalAction]);

  const handleEditClick = () => {
    setIsEditing(true);

    setTimeout(() => {
      // @ts-ignore
      $inputRef.current?.focus();
    }, 50);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setEditedText(selectedGoalAction?.goal?.goal_name || '');
  };

  const handleSaveClick = () => {
    setIsSaving(true);

    // Use the onUpdate function passed as prop
    if (selectedGoalAction?.id && selectedGoalAction?.goal?.id) {
      onUpdate(
        { goal_name: editedText.trim() },
        selectedGoalAction.id,
        selectedGoalAction.goal.id,
        () => {
          setIsEditing(false);
          setIsSaving(false);
          setEditedText(editedText.trim());
        }
      );
    } else {
      // Fallback in case IDs are missing
      setIsEditing(false);
      setIsSaving(false);
    }
  };

  const handleInputChange = (value: string) => {
    setEditedText(value);
  };

  const handleInputKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSaveClick();
    }
  };

  return (
    <Wrapper>
      <Header>
        <ColumnLeft>
          <Heading>Goal</Heading>
        </ColumnLeft>
        <ColumnRight>
          {isEditing ? (
            <ButtonsWrapper>
              <CancelButton
                onClick={handleCancelClick}
                disabled={isSaving}
              >
                Cancel
              </CancelButton>
              <Button
                styleType="primary"
                size="small"
                version="new"
                onClick={handleSaveClick}
                disabled={editedText === (selectedGoalAction?.goal?.goal_name || '') || isSaving}
              >
                {isSaving ? 'Saving...' : 'Save'}
              </Button>
            </ButtonsWrapper>
          ) : (
            <EditButton onClick={handleEditClick}>Edit</EditButton>
          )}
        </ColumnRight>
      </Header>
      <Body>
        {isEditing ? (
          <InputAreaAI
            id="input-goal"
            value={editedText}
            name="goal"
            placeholder="Enter goal"
            style={{ padding: 12, paddingRight: 34, fontSize: 14, lineHeight: '20px', wordBreak: 'break-word', maxHeight: 180 }}
            max={255}
            ref={$inputRef}
            onChange={handleInputChange}
            onKeyDown={handleInputKeyDown}
            disabled={isSaving}
            assistant={{
              type: DataType.GOAL,
              title: "Goal",
              order: "1",
              area: selectedGoalAction?.goal?.area || "",
              category: "Goal",
              goal: selectedGoalAction?.goal?.goal_name,
              prompt: editedText
            }}
          />
        ) : (
          <BodyText onClick={handleEditClick}>
            {selectedGoalAction?.goal?.goal_name}
          </BodyText>
        )}
      </Body>
    </Wrapper>
  );
};

export default Goal;